import { render, staticRenderFns } from "./HowWorks.vue?vue&type=template&id=18b6305d"
import script from "./HowWorks.vue?vue&type=script&lang=js"
export * from "./HowWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports